import { getzntScShopList, getActivityFloorList, getActivityGoodList, queryRecommendPointsMap, queryPointsByPtType, queryRecommendPointsOrderList } from "@/api/channel";

export default {
  namespaced: true,
  actions: {
    async getzntScShopList(context, params) {
      const { data } = await getzntScShopList(params);
      return data;
    },

    async getActivityFloorList(context, params) {
      const { data } = await getActivityFloorList(params);
      return data;
    },

    async getActivityGoodList(context, params) {
      const { data } = await getActivityGoodList(params);
      return data;
    },

    async queryRecommendPointsMap() {
      const { data } = await queryRecommendPointsMap();
      return data;
    },

    async queryPointsByPtType(context, params) {
      const { data } = await queryPointsByPtType(params);
      return data;
    },

    async queryRecommendPointsOrderList(context, params) {
      const { data } = await queryRecommendPointsOrderList(params);
      return data;
    }
  }
};
